// extracted by mini-css-extract-plugin
export var numberInputContainer = "_4r-0";
export var startPickingButton = "_4r-1";